import { create } from "zustand";

export const useModal = create((set) => ({
	data: {},
	isOpen: false,
	onOpen: () => set({ isOpen: true }),
	onClose: () => set({ isOpen: false }),
	setData: (data) => set({ data }),
}));
